import api from './axiosConfig';
import CustomEventDispatcher from './CustomEventDispatcher';

class DebtorService extends CustomEventDispatcher {

  async getDebtors() {
    try {
      const response = await api.get('/api/debtors');
      const event = new CustomEvent('debtorsLoaded', { detail: response.data });
      this.dispatchEvent(event);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        this._dispatchUnauthorized();
      } else {
        console.error('Fout bij het ophalen van debiteuren:', error);
        this._dispatchCustomEvent('getDebtorsFailed', error.response ? error.response.data : error);
      }
      throw error;
    }
  }

  async getDebtor(id) {
    try {
      const response = await api.get(`/api/debtors/${id}`);
      const event = new CustomEvent('debtorLoaded', { detail: response.data });
      this.dispatchEvent(event);
      return response.data;
    } catch (error) {
      console.error('Fout bij het ophalen van debiteur:', error);
      this._dispatchCustomEvent('getDebtorFailed', error.response ? error.response.data : error);
      throw error;
    }
  }

  async getDebtorsByCustomerId(customerId) {
    try {
      const response = await api.get(`/api/debtors/customer/${customerId}`);
      const event = new CustomEvent('customerDebtorsLoaded', { detail: response.data });
      this.dispatchEvent(event);
      return response.data;
    } catch (error) {
      console.error(`Fout bij het ophalen van debiteuren voor klant ${customerId}:`, error);
      this._dispatchCustomEvent('getCustomerDebtorsFailed', error.response ? error.response.data : error);
      throw error;
    }
  }

  async createDebtor(debtor) {
    try {
      const response = await api.post('/api/debtors', debtor);
      const event = new CustomEvent('debtorCreated', { detail: response.data });
      this.dispatchEvent(event);
      return response.data;
    } catch (error) {
      console.error('Fout bij het aanmaken van debiteur:', error);
      this._dispatchCustomEvent('createDebtorFailed', error.response ? error.response.data : error);
      throw error;
    }
  }

  /**
   * Update een bestaande debiteur
   * @param {number} id - ID van de debiteur
   * @param {Object} debtor - Debiteur gegevens om bij te werken
   * @returns {Promise<Object>} De bijgewerkte debiteur
   */
  async updateDebtor(id, debtor) {
    try {
      const response = await api.put(`/api/debtors/${id}`, debtor);
      const event = new CustomEvent('debtorUpdated', { detail: response.data });
      this.dispatchEvent(event);
      return response.data;
    } catch (error) {
      console.error('Fout bij het bijwerken van debiteur:', error);
      this._dispatchCustomEvent('updateDebtorFailed', error.response ? error.response.data : error);
      throw error;
    }
  }

  async deleteDebtor(id) {
    try {
      const response = await api.delete(`/api/debtors/${id}`);
      const event = new CustomEvent('debtorDeleted', { detail: id });
      this.dispatchEvent(event);
      return response.data;
    } catch (error) {
      console.error('Fout bij het verwijderen van debiteur:', error);
      this._dispatchCustomEvent('deleteDebtorFailed', error.response ? error.response.data : error);
      throw error;
    }
  }

  async updateDebtorEmails(id, emails) {
    try {
      const response = await api.put(`/api/debtors/${id}/emails`, { emails });
      const event = new CustomEvent('debtorEmailsUpdated', { detail: response.data });
      this.dispatchEvent(event);
      return response.data;
    } catch (error) {
      console.error('Fout bij het bijwerken van debiteur e-mails:', error);
      this._dispatchCustomEvent('updateDebtorEmailsFailed', error.response ? error.response.data : error);
      throw error;
    }
  }
}

export default DebtorService;
